import Vue from 'vue'
import store from '../store/index'

export default {
  namespaced: true,
  state: {
    esatDriverSummary: [],
    esatData: [],
    sort: {
      type: 'total_count',
      orderBy: 'desc'
    },
    sortOptions: [
      { name: 'Review volume', alias: 'total_count', value: 'desc' },
      { name: 'Features', alias: 'topic_name', value: 'desc' },
      { name: 'Rating', alias: 'e_sat_avg', value: 'desc' }
    ],
    driverView: 0,
    showTotal: false,
    localSelectedCompany: {},
    sentimentScoreDataTotal: [],
    sentimentScoreDataNMinusOne: [],
    sentimentScoreDataSingle: []
  },
  actions: {
    /** This method gets the data for the CSAT drivers page. It also extracts (from session storage) the value of the last selected view and saves that to the store. This helps in persisting that view througout page changes. */
    getEsatDriverSummary ({ commit, state }, value) {
      commit('LOADING', true)
      const view = sessionStorage.getItem('esatDriverView')
      if (view) {
        state.driverView = JSON.parse(view)
      }
      Vue.prototype.$http.post('/report/getCsatByTopic', value).then((response) => {
        if (response.data.status === 200) {
          if (response.data && response.data.data) {
            commit('ESAT_DRIVER_SUMMARY', response.data.data)
          }
        }
        commit('LOADING', false)
      }).catch(e => {
        commit('LOADING', false)
      })
    },
    /** This method gets the correlation data for all products for the Kano Chart. The y-axis value for all bubbles are set using the correlationCoeff returned in this method. If there is no selected product (no comparison is being made) the x-axis values for the bubbles are also obtained from the values returned in this method. (avg Satisfaction) */
    getSentimentRatingCorrelationTotal ({ commit }, value) {
      Vue.prototype.$http.post('/topic/sentimentRatingCorrelation', value).then((response) => {
        if (response.data.status === 200) {
          if (response.data && response.data.data) {
            commit('UPDATE_SENTIMENT_SCORE_TOTAL', response.data.data)
          }
        }
      }).catch(e => {
        // commit('LOADING', false)
      })
    },
    /** This method returns the correlation data for only the selected product on the Kano Chart view. The x-axis bubbles for the solid bubbles (when a comparison is being made) are set using the avgSatisfaction values returned through this method. */
    getSentimentRatingCorrelationSingle ({ commit }, value) {
      if (value === null) {
        commit('UPDATE_SENTIMENT_SCORE_SINGLE', [])
      } else {
        Vue.prototype.$http.post('/topic/sentimentRatingCorrelation', value).then((response) => {
          if (response.data.status === 200) {
            if (response.data && response.data.data) {
              commit('UPDATE_SENTIMENT_SCORE_SINGLE', response.data.data)
            }
          }
        }).catch(e => {
          // commit('LOADING', false)
        })
      }
    },
    /** This method returns the correlation data for all products excluding the selected product, on the Kano Chart view. The x-axis bubbles for the hollow bubbles (when a comparison is being made) are set using the avgSatisfaction values returned through this method. */
    getSentimentRatingCorrelationNMinusOne ({ commit }, value) {
      Vue.prototype.$http.post('/topic/sentimentRatingCorrelation', value).then((response) => {
        if (response.data.status === 200) {
          if (response.data && response.data.data) {
            commit('UPDATE_SENTIMENT_SCORE_N_MINUS_ONE', response.data.data)
          }
        }
      }).catch(e => {
        // commit('LOADING', false)
      })
    },
    updateEsatDriverData ({ commit }, payload) {
      commit('ESAT_DATA', payload)
    },
    /** This method sets the criteria by which drivers must be sorted */
    updateSort ({ commit }, value) {
      commit('UPDATE_SORT', value)
    },
    /** This method updates the view to be displayed on the CSAT Drivers page, to whatever was selected in the dropdown menu on the page. */
    updateDriverDisplayMode ({ commit, state }, value) {
      commit('UPDATE_DRIVER_DISPLAY_MODE', value)
      for (const option of state.sortOptions) {
        if (option.name === 'Rating' && value) {
          option.name = '% of Likes'
          option.alias = 'like'
          option.value = 'asc'
        } else if (option.name === '% of Likes' && !value) {
          option.name = 'Rating'
          option.alias = 'e_sat_avg'
          option.value = 'asc'
        }
      }
      commit('UPDATE_SORT', {
        type: 'total_count',
        orderBy: 'desc'
      })
      commit('UPDATE_SORT_OPTIONS', state.sortOptions)
    },
    /** This method selects a company whose data needs to be compared against the avg of the rest of the companies on the Kano chart */
    updateSelectedCompany ({ commit }, value) {
      commit('UPDATE_SELECTED_COMPANY', value)
    },
    /**
     * This method hides/displays the *All Products/Company Total* column in the CSAT/ESAT Drivers table
     */
    toggleShowTotal ({ commit }) {
      commit('TOGGLE_SHOW_TOTAL')
    }
  },
  mutations: {
    ESAT_DRIVER_SUMMARY (state, payload) {
      state.esatDriverSummary = payload
    },
    LOADING (state, payload) {
      store.state.filters.loading = payload
    },
    ESAT_DATA (state, payload) {
      state.esatData = payload
    },
    UPDATE_SORT (state, payload) {
      state.sort = payload
      const options = state.sortOptions
      for (const option of options) {
        if (option.alias === payload.type) {
          option.value = payload.orderBy
        }
      }
      state.sortOptions = options
    },
    UPDATE_SORT_OPTIONS (state, payload) {
      state.sortOptions = payload
    },
    UPDATE_DRIVER_DISPLAY_MODE (state, payload) {
      sessionStorage.setItem('esatDriverView', payload)
      state.driverView = payload
    },
    UPDATE_SELECTED_COMPANY (state, payload) {
      state.localSelectedCompany = payload
    },
    UPDATE_SENTIMENT_SCORE_TOTAL (state, payload) {
      state.sentimentScoreDataTotal = payload
    },
    UPDATE_SENTIMENT_SCORE_SINGLE (state, payload) {
      state.sentimentScoreDataSingle = payload
    },
    UPDATE_SENTIMENT_SCORE_N_MINUS_ONE (state, payload) {
      state.sentimentScoreDataNMinusOne = payload
    },
    TOGGLE_SHOW_TOTAL (state) {
      state.showTotal = !state.showTotal
    }
  }
}
